import { Component } from '@angular/core';

@Component({
  selector: 'empathy-file-upload-description',
  templateUrl: 'file-upload-description.component.html',
  styleUrls: ['./file-upload-description.component.scss']
})
export class FileUploadDescriptionComponent {}
